"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GrowthYouOwn() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section id="growth-you-own" className="relative min-h-[90vh] flex flex-col justify-center items-center overflow-hidden bg-background pt-20 pb-16 lg:pt-32 lg:pb-24">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-40" style={{
      backgroundImage: `linear-gradient(to right, var(--color-border) 1px, transparent 1px), 
                           linear-gradient(to bottom, var(--color-border) 1px, transparent 1px)`,
      backgroundSize: '40px 40px'
    }} />

      {}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_top_right,var(--color-primary)_0%,transparent_35%)] opacity-5" />

      {}
      <div className="absolute inset-0 pointer-events-none bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1443870/img/higher_ed_campus_growth_vision.png)] opacity-75" />

      <h2 className="container relative z-10 mx-auto px-4 font-sans uppercase tracking-[0.2em] mb-8 !text-[40px] !text-[hsl(242,47%,34%)] !font-extrabold sm:px-6 lg:px-8">EMPOWERING HIGHER EDUCATION FOR THE FUTURE</h2>

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="font-serif text-[hsl(242,47%,34%)] text-6xl sm:text-7xl md:text-8xl lg:text-[6rem] font-bold leading-[0.9] tracking-tight mb-8">
              Growth <br />
              <span className="text-secondary">You Own</span>
            </h1>

            {}
            <div className="pl-2 md:pl-4 lg:pl-6 border-l-2 border-accent/50 mt-4 lg:mt-8 max-w-xl">
              <p className="text-lg font-sans leading-relaxed !text-[hsl(210,14%,89%)] md:text-2xl">
                We build capability with you, not dependency on us.
              </p>
            </div>

            <div className="mt-12 flex flex-wrap gap-4">
              <Button asChild size="lg" className="text-base px-8 h-14 rounded-none uppercase tracking-wider font-bold bg-primary hover:bg-primary/90 text-white shadow-lg hover:shadow-xl transition-all">
                <Link to="https://edustrategygroup.com/schedule-your-strategy-session/">
                  Start a Conversation <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="text-base px-8 h-14 rounded-none uppercase tracking-wider font-bold border-primary text-primary hover:bg-primary/5">
                <Link to="/services">
                  Explore Services
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative h-[400px] lg:h-[600px] w-full flex items-center justify-center perspective-1000">
            {mounted && <div className="relative w-full h-full max-w-[500px] max-h-[500px]">
                {}
                <div className="absolute inset-0 flex items-center justify-center animate-[spin_60s_linear_infinite]">
                  <svg viewBox="0 0 400 400" className="w-full h-full opacity-20 text-primary fill-current">
                    <path d="M200,40 A160,160 0 1,0 360,200 L300,200 A100,100 0 1,1 200,100 L200,40 Z" />
                  </svg>
                </div>

                {}
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-8">
                  <div className="w-48 h-4 bg-secondary/80 rounded-sm shadow-sm animate-[pulse_4s_ease-in-out_infinite]" />
                  <div className="w-32 h-4 bg-primary/60 rounded-sm shadow-sm translate-x-8 animate-[pulse_4s_ease-in-out_infinite_1s]" />
                  <div className="w-56 h-4 bg-secondary/80 rounded-sm shadow-sm -translate-x-4 animate-[pulse_4s_ease-in-out_infinite_2s]" />
                </div>

                {}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 border-2 border-accent rounded-full opacity-40 animate-[ping_8s_cubic-bezier(0,0,0.2,1)_infinite]" />
                
                {}
                <div className="absolute top-20 right-20 w-12 h-12 border border-primary/20 rotate-45" />
                <div className="absolute bottom-32 left-10 w-8 h-8 bg-accent/30 rounded-full" />
              </div>}
          </div>
        </div>
      </div>
    </section>;
}